import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { zim } from '../zegoConfig';
import { generateToken } from '../components/utils/tokenUtils';

const Login: React.FC<{ onLogin: (userId: string, username: string) => void }> = ({ onLogin }) => {
  const [userId, setUserId] = useState('');
  const [username, setUsername] = useState('');
  const navigate = useNavigate(); // redirect handler

  const handleLogin = async () => {
    const appID = Number(process.env.REACT_APP_ZEGOCLOUD_APP_ID);
    
    if (!appID) {
      console.error("AppID tidak ditemukan. Pastikan tersedia di file .env");
      return;
    }
    
    try {
      const token = await generateToken(userId);
      await zim.login({ userID: userId, userName: username }, token);
      onLogin(userId, username);
      console.log("Login berhasil");

      // Redirect ke halaman utama atau chat
      navigate('/chat');
    } catch (error) {
      console.error("Login gagal:", error);
    }
  };

  return (
    <div>
      <h2>Login</h2>
      <input
        type="text"
        placeholder="User ID"
        value={userId}
        onChange={(e) => setUserId(e.target.value)}
      />
      <input
        type="text"
        placeholder="Username"
        value={username}
        onChange={(e) => setUsername(e.target.value)}
      />
      <button onClick={handleLogin}>Login</button>
    </div>
  );
};

export default Login;
